import { api } from "./api";

/**
 * The server spells this prefix "calender", not "calendar", and every holiday
 * route lives under it. Declared once here so the misspelling is stated in a
 * single place rather than repeated across call sites — the point being that
 * someone adding a calendar route later does not reach for the correct spelling
 * and get a route that silently does not exist.
 *
 * Verified against the live API on 2026-08-13: `/calender/getHolidaysByMonth`
 * responds (auth-gated), while `/calendar/getHolidaysByMonth` and
 * `/calendar/addHoliday` both return the API's "Page not found" body. Note that
 * this backend answers 404s with HTTP 200, so a correctly-spelled request would
 * not throw — it would look like an empty month.
 *
 * Renaming is a backend-led change: add the correctly-spelled routes as aliases,
 * flip this constant, then retire the old paths. Nothing else needs to change.
 */
const CALENDAR = "/calender";

export const GetHolidaysByMonthApi = (year: number, month: number) => {
  return api.get(`${CALENDAR}/getHolidaysByMonth?year=${year}&month=${month}`);
};

export const AddHolidayApi = (data: { holiday_date: string; reason?: string }) => {
  return api.post(`${CALENDAR}/addHoliday`, data);
};

export const RemoveHolidayApi = (data: { holiday_date: string }) => {
  return api.post(`${CALENDAR}/removeHoliday`, data);
};
